import "./style.scss";
import * as Assets from "../../utils/svg_assets";
import { Col, Row } from "react-bootstrap";

export const FitureUnderDevelopmentHeader = ({ info = "Header" }) => {
  return (
    <Row className="fud-header">
      <Col xs={2} sm={2} md={2} className="img-cont">
        <img src={Assets.page_under_construct} alt="page_under_construct" />
      </Col>
      <Col xs={8} sm={8} md={8}>
        {info}
      </Col>
    </Row>
  );
};

export const FitureUnderDevelopmentBody = ({
  info = "Content is still under development",
}) => {
  return (
    <div className="fud-body">
      <h3>PAGE UNDER CONSTRUCTION</h3>
      <img src={Assets.page_under_construct} alt="page_under_construct" />
      <p>{info}</p>
    </div>
  );
};
